export default "__VITE_ASSET__5ed993b1__"